import React from "react";
import { C } from "../theme";
import Button from "../components/Button";

// One-time welcome card shown the first time an angler reaches the app after
// signing up and logging in. Dismissal is persisted by the caller (App.jsx)
// via a localStorage flag so it never appears again on that install.
//
// Rendered as its own full shell (like the enrollment/verify screens) so it
// stays inside the phone-frame boundaries and honors safe-area insets.
export default function WelcomeScreen({ onStart }) {
  return (
    <div
      style={{
        flex: 1,
        minHeight: 0,
        width: "100%",
        overflowY: "auto",
        WebkitOverflowScrolling: "touch",
        background: `linear-gradient(180deg, ${C.deepWater} 0%, ${C.dark} 100%)`,
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          boxSizing: "border-box",
          padding: "max(20px, env(safe-area-inset-top)) 20px max(20px, env(safe-area-inset-bottom))",
        }}
      >
        <div style={{ fontSize: 11, color: C.accent, letterSpacing: 4, marginBottom: 6 }}>
          WELCOME TO
        </div>
        <div
          style={{
            fontSize: 30,
            fontFamily: "Georgia, serif",
            fontWeight: 700,
            color: C.white,
            letterSpacing: 1,
            marginBottom: 16,
          }}
        >
          THE 99
        </div>

        <div style={{ fontSize: 13, lineHeight: 1.6, color: C.sand, display: "flex", flexDirection: "column", gap: 12 }}>
          <p style={{ margin: 0 }}>
            Fishing is{" "}
            <strong style={{ color: C.white }}>99% preparation and 1% execution.</strong>{" "}
            That belief is the heart of THE 99 — and of the book it's built on,{" "}
            <em style={{ color: C.white }}>Before the Cast</em>. If you haven't read it yet, it's
            worth your time.
          </p>
          <p style={{ margin: 0 }}>
            You get better in the 99%, and that comes from learning from every trip you take. THE 99
            logs the weather, tide, moon phase, and temperature behind your best days — and your slow
            ones — then uses AI to turn those patterns into a plan for your next trip. Strategies
            build over time, and you'll see the progress.
          </p>
          <p style={{ margin: 0 }}>
            Every sport has a coach: someone who tracks your progress and sharpens your instincts
            until you can define your own strategy.{" "}
            <strong style={{ color: C.white }}>THE 99 is your coach.</strong> Once your skills are
            dialed in, put your data to work in tournaments — or run your own.
          </p>
          <p style={{ margin: 0 }}>
            Fish move and conditions never sit still, so someone else's "spots" are worthless —
            they're either played out or too public to fish. THE 99 doesn't hand you a pin on a map.
            It builds the one thing that lasts:{" "}
            <strong style={{ color: C.white }}>your own skill.</strong>
          </p>
          <p style={{ margin: "2px 0 0", color: C.accent, fontWeight: 700, letterSpacing: 0.5 }}>
            Tight lines. Let's get to work.
          </p>
        </div>

        <div style={{ marginTop: 28 }}>
          <Button variant="primary" fullWidth onClick={onStart} data-testid="welcome-start">
            Start Preparing
          </Button>
        </div>
      </div>
    </div>
  );
}
